import { GoogleMapsLoader } from 'util/maps';

export const useGoogleMaps = options => {
  if (GoogleMapsLoader.isLoaded) {
    return;
  }
  GoogleMapsLoader.load(options);
};
